import { render, staticRenderFns } from "./HospitalPage.vue?vue&type=template&id=d7886d36&scoped=true"
import script from "./HospitalPage.vue?vue&type=script&lang=js"
export * from "./HospitalPage.vue?vue&type=script&lang=js"
import style0 from "./HospitalPage.vue?vue&type=style&index=0&id=d7886d36&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7886d36",
  null
  
)

export default component.exports